// export {
//   easeIn,
//   easeOut,
//   easeInOut,
//   anticipate,
//   steps,
//   cubicBezier,
// } from "motion";

export const linear = (x: number) => x;
